<template>
  <div class="overflow-hidden bg-white shadow sm:rounded-lg">
    <section>
      <div class="px-4 py-5 sm:px-6">
        <h3 class="text-2xl font-bold leading-8 text-gray-900 my-4">
          {{ practice.claim }}
        </h3>
        <p class="text-base font-medium leading-6">
          {{ practice.teaser }}
        </p>
      </div>
      <div class="border-t border-gray-200 px-4 py-5 sm:p-0">
        <dl class="sm:divide-y sm:divide-gray-200">
          <div v-if="words" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              Schlagworte
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
              <ul role="list" class="leading-8">
                <li class="inline" v-for="keyword in practice.keywords">
                  <span class="relative inline-flex items-center rounded-full border border-gray-300 px-3 py-0.5">
                    <div class=" text-sm font-medium text-gray-900">
                      {{ keyword.title }}
                    </div>
                  </span>
                  {{ ' ' }}
                </li>
              </ul>
            </dd>
          </div>
        </dl>
        <div v-if="success" class="border-t border-gray-200 px-4 py-5 sm:p-0">
          <Markdown :content="resource.description" />
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRetrieveResource } from '@/client/actions';

const props = defineProps({practice: Object});

const parent = computed(() => props.practice.id);
const target = computed(() => '/api/practices/' + parent.value + '/content');

const { retrieve, retrieving, resource, success, failure } = useRetrieveResource(target);

const format = (v) => parseFloat(v * 100).toFixed(0) + "%";

const score = computed(() => format(props.practice.similarity));
const words = computed(() => props.practice.keywords.length > 0);

const onMount = onMounted(() => retrieve());
</script>
